import DocumentTitle from 'react-document-title';
import React from 'react';

import './Auth.scss';
import './auth-page.scss';
import Logo from 'src/components/Logo';
import { Images } from 'src/Tenants';
import { useBranding } from 'src/branding/BrandingContextProvider';

interface IAuthProps {
  backgroundImage: string;
  content: React.ReactNode;
  title: string;
}

const Auth: React.FC<IAuthProps> = ({ backgroundImage, content, title }) => {
  let theme = localStorage.getItem('theme');
  const { branding } = useBranding();

  return (
    <DocumentTitle
      title={`${title} | ${branding.text.applicationName || 'juniper'}`}
    >
      <>
        <div className="auth">
          <div className="auth__content">
            <Logo />
            {content}
          </div>
          <div className="auth__aside">
            <div
              className={
                // TODO: is Formworks still an active tenant?
                theme === 'Formwerks' ? 'auth__formwerks_photo' : 'auth__photo'
              }
              style={{ backgroundImage: `url("${backgroundImage}")` }}
            >
              <div
                className={
                  theme === 'Formwerks'
                    ? 'auth__enticer enticer'
                    : 'auth__enticer'
                }
              >
                {Images.loginScreenDescription}
              </div>
            </div>
          </div>
        </div>
      </>
    </DocumentTitle>
  );
};

export default Auth;
